<!-- 
CustDataViewPermissionModal.vue
功能：客戶資料檢視權限_解除紀錄
作者：i94005pi01 周厚鈞
完成：2022-11-03
-->
<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">解除紀錄</h3>
        </div>
        <div class="modal-body">
      <table class="table table-basic">
        <thead>
          <tr>
            <th class="w-220">設定人員</th>          
            <td>
              <Tooltip
                  :position="index < 3 ? 'bottom' : 'top'"
                  expand_col1="設定人員"
                  :expand_col1_value="permissionInfo.upd_name"
                  expand_col2="客戶ID"
                  :expand_col2_value="permissionInfo.id"
                  expand_col3="業務員ID"
                  :expand_col3_value="permissionInfo.agnt_id"
              >
                {{ permissionInfo.upd_name | getMaskName }}
              </Tooltip> 
            </td>
          </tr>
          <tr>
            <th class="w-220">簡覆表編號</th>
            <td>{{ permissionInfo.form_no }}</td>
          </tr>
          <tr>
            <th class="w-220">申請日期</th>
            <td>{{ permissionInfo.in_date | dateFormat }}</td>
          </tr>
          <tr>
            <th class="w-220">客戶ID</th>
            <td>{{ permissionInfo.id | getMaskID }}</td>
          </tr>
          <tr>
            <th class="w-220">設定範圍</th>
            <td>{{ permissionInfo.in_type == '1' ? '特定業務員' : '全部業務員' }}</td>
          </tr>
          <tr>
            <th class="w-220">業務員ID</th>
            <td>{{ permissionInfo.agnt_id | emptyField | getMaskID }}</td>
          </tr>
          <tr>
            <th class="w-220">原因</th>
            <td>{{ permissionInfo.memo }}</td>
          </tr>
        </thead>
      </table>
      <table class="table table-basic mt-4">
        <thead>
          <tr>
            <th class="w-220">設定人員</th>
            <td>
              <Tooltip
                  :position="index < 3 ? 'bottom' : 'top'"
                  expand_col1="設定人員"
                  :expand_col1_value="permissionInfo.del_name"
              >
              {{ permissionInfo.del_name| getMaskName }}
              </Tooltip> 
            </td>
          </tr>
          <tr>
            <th class="w-220">簡覆表編號</th>
            <td>{{ permissionInfo.del_form_no }}</td>
          </tr>
          <tr>
            <th class="w-220">申請日期</th>
            <td>{{ permissionInfo.del_time | dateFormat }}</td>
          </tr>
          <tr>
            <th class="w-220">設定範圍</th>
            <td>取消權限設定</td>
          </tr>
          <tr>
            <th class="w-220">異動原因</th>
            <td>{{ permissionInfo.del_memo }}</td>
          </tr>
        </thead>
      </table>
        </div>
        <div class="modal-footer">
          <div class="text-right">
            <a @click="$emit('close')" class="btn btn-primary">關閉</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from "@/desktop/components/ToolTip";
export default {
  name: "CustDataViewPermissionModal",
  components: { 
    Tooltip
   },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    permissionInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
};
</script>
<style scoped>
.modal.fade .modal-body {
  min-height: auto;
}
</style>
